import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const ListContainer = props => {
    const { children, title, ...rest } = props;

    return (
        <Box
            sx={theme => ({
                padding: '60px 20px 34px',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                height: `calc(100% - ${theme.constants.footerHeight}px)`,
            })}
            {...rest}
        >
            {title && (
                <Typography variant="h5" align="left" gutterBottom>
                    {title}
                </Typography>
            )}
            {children}
        </Box>
    );
};

ListContainer.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
};

export default ListContainer;
